import {gql} from '@apollo/client';

import {doQuerySafe} from 'graphql-client/ApolloWrappers';
import {BenchlingQueryResult, useBenchlingQuery} from 'graphql-client/BenchlingQuery';
import {getFragmentWrapper} from 'graphql-client/declarative-translations/external/getFragmentWrapper';

import {AllSchemaInterfacesQuery} from './__generated/AllSchemaInterfacesQuery';

export const ALL_SCHEMA_INTERFACES_QUERY = gql`
  query AllSchemaInterfacesQuery @skipAudit @engComponent(name: INVENTORY) {
    ...AllSchemaInterfacesGraphQL
  }
  ${getFragmentWrapper('AllSchemaInterfaces').fragment}
`;

export function useAllSchemaInterfacesQuery(): BenchlingQueryResult<AllSchemaInterfacesQuery> {
  const result = useBenchlingQuery<AllSchemaInterfacesQuery>(ALL_SCHEMA_INTERFACES_QUERY);
  return result;
}

export function doAllSchemaInterfacesQuery(): Promise<AllSchemaInterfacesQuery> {
  return doQuerySafe<AllSchemaInterfacesQuery, {}>({query: ALL_SCHEMA_INTERFACES_QUERY});
}
